import type { FaireProductEntity } from "../../entity_types/product";

export const caden_lane_3: FaireProductEntity = {
  token: "caden-lane-3",
  type: "product",
  name: "Sweet Like Candy Ruffle Zipper Footie | Pink",
  brandName: "Caden Lane",
  imageUrl:
    "https://cdn.faire.com/fastly/fad228e685f479701e431f321beaa67671f9c46000f8a84bf192212f96a78ef3.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=1798,1798,x0,y0,safe&width=720",
  priceDollars: 19,
  msrpDollars: 38,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_apparel-baby"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
